export const stores = state => state.stores
export const store = state => state.store
export const statusStores = state => state.statusStores
